import { StandardInput } from "@/components/ui/forms/standardInput"
import { Chip } from "@/components/ui/baseUi/chip"
import { ChipGroup } from "@/components/ui/baseUi/chip-groupe"
import { Text } from "@/components/ui/baseUi/text"
import { getFormErrorMessage } from "@/modules/formik/formikUtils"
import { cn } from "@/modules/lib/utils"
import { ExerciseCategories } from "@/modules/sessions/sessionDetails/blocks/exerciseBlock/exerciseTypes"
import { getDisplayExerciseCategory } from "@/modules/sessions/sessionDetails/blocks/exerciseBlock/exerciseUtils"
import type {
  ExerciseFormikType,
  ExerciseInputKey,
} from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import type { SimpleFormik } from "@/typings/formik"
import { word } from "@modules/core/utils/i18n"

export function ExerciseCategoryInput({
  formik,
  className,
  ...props
}: { formik: SimpleFormik<ExerciseFormikType, ExerciseInputKey> } & React.ComponentProps<"div">) {
  const exercisesCategory = ExerciseCategories.map((exerciseCategory) => {
    return { value: exerciseCategory, label: getDisplayExerciseCategory(exerciseCategory, null) }
  })

  return (
    <div className={cn("rounded-2xl bg-surface-foreground px-5 py-6", className)} {...props}>
      <Text fontStyle="LS" className="text-textDefault-body uppercase">
        {word("sessionForm.exercise.category.label")}
        <Text fontStyle="LL" className="text-textError">
          {" *"}
        </Text>
      </Text>

      <ChipGroup
        spacing={1}
        variant="emphasisHigh"
        className="mt-2 w-full flex-wrap"
        value={[formik.values.category]}
      >
        {exercisesCategory.map((category) => (
          <Chip
            value={category.value}
            key={category.value}
            variant="emphasisHigh"
            size="md"
            aria-pressed={formik.values.category === category.value}
            onClick={() => {
              void formik.setFieldValue("category", category.value)
            }}
          >
            {category.label}
          </Chip>
        ))}
      </ChipGroup>

      {getFormErrorMessage("category", formik)}

      {formik.values.category === "OTHER" && (
        <StandardInput
          isRequiredInput
          getFieldProps={formik.getFieldProps}
          name="otherCategory"
          error={getFormErrorMessage("otherCategory", formik)}
          setFieldValue={formik.setFieldValue}
          containerClassName="mt-2"
          inputProps={{
            className: "bg-surface-background",
            placeholder: word("sessionForm.exercise.category.other.placeHolder"),
          }}
        />
      )}
    </div>
  )
}
